<template>
	<div>
		<AttachmentSection :files='files' v-if='files' />
		<InformationSection :sections='information' />

		<ServiceTabs :items='services' title='Provider services' />

		<CountryIterator
			:mainItems='primarProviders'
			:otherItems='otherProviders'
			mainTitle='Primar RENC Members'
			otherTitle='Other PRIMAR RENC Providers'
			title='PRIMAR Provider Network'
		/>
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'

import ServiceTabs from '@/components/n-collections/ServiceTabs'

import SectionContainer from '@/components/base/SectionContainer'
import CountryIterator from '@/components/n-collections/CountryIterator'

import InformationSection from '@/components/base/InformationSection'
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	name: 'Providers',

	components: {
		ServiceTabs,
		SectionContainer,
		CountryIterator,
		InformationSection,
		AttachmentSection
	},

	metaInfo: {
    title: 'Hydrographic Offices'
  },

	data() {
		return {
			primarProviders: [],
			otherProviders: [],
			services: [],
			information: [],
			files: []
		}
	},

	async created() {
		const {
			text,
			services,
			primarProviders,
			otherProviders,
			files
		} = await ContentService.get('providers')

		this.information.push({ title: 'PRIMAR Providers', text })

		this.services = services
		this.primarProviders = primarProviders
		this.otherProviders = otherProviders
		this.files = files
	},
}
</script>